export enum EmailVerificationType {
  Signup = "signup",
  Change = "change",
  CheckOld = "check_old",
}
